import React from "react";

type FadeInProps = {
  duration?: number;
  delay?: number;
  children: React.ReactNode;
  [key: string]: any;
};

export const FadeIn = ({
  duration = 300,
  delay = 0,
  children,
  ...delegated
}: FadeInProps) => {
  return (
    <div
      className="fadein-wrapper"
      {...delegated}
      style={{
        ...(delegated.style || {}),
        animationDuration: duration + "ms",
        animationDelay: delay + "ms",
      }}
    >
      {children}
    </div>
  );
};
